import Vue from 'vue';
import store from '../../store';

const success = (resolve, response) => {
  store.dispatch('fetchAllRecipeProducts', response.data.products);
  resolve();
};

const failed = (error, reject) => {
  reject(error);
};

export default (recipeId, productId) => (
  new Promise((resolve, reject) => {
    Vue.$http.delete(`/production/recipe/${recipeId}/product/${productId}`)
    .then((response) => {
      success(resolve, response.data);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipe/destroyProduct.js